export { appendHtml, replaceHtml };

function appendHtml(container, html) {
  const range = document.createRange();
  range.setStart(container, 0);
  range.setEnd(container, 0);
  container.appendChild(range.createContextualFragment(html));
}

function replaceHtml(container, html) {
  // eslint-disable-next-line no-param-reassign
  container.innerHTML = "";
  appendHtml(container, html);
}
